import React, { useEffect, useMemo, useState } from "react";

const ErrorLanding = () => {
  const hostname = window.location.hostname;
  const pathname = window.location.pathname;

  /* ===============================
   * localhost デバッグ切替
   * =============================== */
  const isLocalhost =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.endsWith(".localhost");

  const [debugTarget, setDebugTarget] = useState(() => {
    return sessionStorage.getItem("error-landing-debug-target") || "geograph";
  });

  useEffect(() => {
    if (isLocalhost) {
      sessionStorage.setItem("error-landing-debug-target", debugTarget);
    }
  }, [debugTarget, isLocalhost]);

  /* ===============================
   * サイト判定
   * =============================== */
  const isGeographHost =
    hostname === "geograph.teikokushoin.co.jp" ||
    hostname === "www.geograph.teikokushoin.co.jp";

  const isMierukaHost =
    hostname.includes("mieruka") ||
    hostname === "v4.mieruka.city" ||
    hostname === "mieruka-v4-map.kashika.net" ||
    hostname === "gg-s.kashika.net";

  const { isGeograph, isMieruka } = useMemo(() => {
    if (!isLocalhost) {
      return {
        isGeograph: isGeographHost,
        isMieruka: isMierukaHost && !isGeographHost,
      };
    }
    return {
      isGeograph: debugTarget === "geograph",
      isMieruka: debugTarget === "mieruka",
    };
  }, [isLocalhost, debugTarget, isGeographHost, isMierukaHost]);

  /* ===============================
   * alert 抑止（表示中のみ）
   * =============================== */
  useEffect(() => {
    const originalAlert = window.alert;
    window.alert = () => {
      //
    };
    return () => {
      window.alert = originalAlert;
    };
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  const getSimilarPage = () => {
    if (pathname.includes("/map")) {
      return "/map/1/11-01/福岡県糸島市";
    }
    return "/select";
  };

  const showTopBar = !isMieruka;
  const showBottomBar = !isMieruka;

  /* ===============================
   * render
   * =============================== */
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2147483647,
        background: "#dbeafe",
        color: "#111",
        overflow: "auto",
        pointerEvents: "auto",
      }}
    >
      {/* localhost デバッグUI */}
      {isLocalhost && (
        <div
          style={{
            position: "fixed",
            top: 10,
            right: 10,
            background: "rgba(255,255,255,0.95)",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            padding: "8px 10px",
            boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
            fontSize: 12,
          }}
        >
          <div style={{ fontWeight: 700, marginBottom: 6 }}>
            localhost debug
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button
              onClick={() => setDebugTarget("geograph")}
              style={{
                padding: "6px 10px",
                borderRadius: 8,
                border: "1px solid #e5e7eb",
                background:
                  debugTarget === "geograph" ? "#374151" : "#fff",
                color:
                  debugTarget === "geograph" ? "#fff" : "#374151",
                cursor: "pointer",
              }}
            >
              ジオグラフ
            </button>
            <button
              onClick={() => setDebugTarget("mieruka")}
              style={{
                padding: "6px 10px",
                borderRadius: 8,
                border: "1px solid #e5e7eb",
                background:
                  debugTarget === "mieruka" ? "#374151" : "#fff",
                color:
                  debugTarget === "mieruka" ? "#fff" : "#374151",
                cursor: "pointer",
              }}
            >
              mieruka
            </button>
          </div>
        </div>
      )}

      {/* 上帯（mieruka では非表示） */}
      {showTopBar && (
        <div
          style={{
            background: "linear-gradient(90deg, #a5f3fc, #60a5fa)",
            padding: "12px 20px",
            fontWeight: 800,
            fontSize: 18,
          }}
        >
          ページの読み込みに問題が発生しました
        </div>
      )}

      {/* 本体 */}
      <div
        style={{
          maxWidth: 900,
          margin: "0 auto",
          padding: showTopBar ? 20 : "24px 20px",
        }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 24,
            boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
            padding: 20,
          }}
        >
          <div style={{ fontSize: 24, fontWeight: 800, color: "#374151" }}>
            うまく表示できませんでした
          </div>

          {/* --- 1回目UI（常時表示） --- */}
          <div style={{ marginTop: 16, color: "#4b5563" }}>
            リンクは正しい可能性があります。まずは再読み込みをお試しください。
          </div>

          <div style={{ marginTop: 16 }}>
            <button
              onClick={handleReload}
              style={{
                background: "#374151",
                color: "#fff",
                padding: "10px 16px",
                borderRadius: 6,
                border: "none",
                boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                cursor: "pointer",
              }}
            >
              もう一度再読み込み
            </button>
          </div>

          {/* --- 2回目以降UI（常時下に表示） --- */}
          <div style={{ marginTop: 24, color: "#4b5563" }}>
            再読み込みしても改善しない場合、次のいずれかをお試しください。
          </div>

          {isGeograph ? (
            <div
              style={{
                marginTop: 12,
                display: "flex",
                gap: 10,
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              <a
                href="/"
                style={{
                  background: "#374151",
                  color: "#fff",
                  padding: "10px 16px",
                  borderRadius: 6,
                  textDecoration: "none",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                }}
              >
                トップページへ
              </a>

              <a
                href={getSimilarPage()}
                style={{
                  background: "#374151",
                  color: "#fff",
                  padding: "10px 16px",
                  borderRadius: 6,
                  textDecoration: "none",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                }}
              >
                似たページへ
              </a>
            </div>
          ) : (
            <div style={{ marginTop: 12, color: "#4b5563" }}>
              時間をおいて再度お試しください。
              <br />
              解決しない場合は事務局までご連絡ください。
            </div>
          )}

          {/* デバッグ表示（不要なら削除可） */}
          {/* <div style={{ marginTop: 20, fontSize: 12, color: "#9ca3af" }}>
            host: {hostname} / path: {pathname}
            {isLocalhost ? ` / debug: ${debugTarget}` : ""}
          </div> */}
        </div>
      </div>

      {/* 下帯（mieruka では非表示） */}
      {showBottomBar && (
        <div
          style={{
            position: "fixed",
            left: 0,
            right: 0,
            bottom: 0,
            height: 32,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#e5e7eb",
            fontWeight: 700,
            background: "linear-gradient(90deg, #2563eb, #1e40af)",
          }}
        >
          © 2021 帝国書院 & 都市構造可視化推進機構
        </div>
      )}
    </div>
  );
};

export default ErrorLanding;
